import { render } from "./MedicareCoverage.vue?vue&type=template&id=3fc829be&scoped=true"
import script from "./MedicareCoverage.vue?vue&type=script&lang=js"
export * from "./MedicareCoverage.vue?vue&type=script&lang=js"

import "./MedicareCoverage.vue?vue&type=style&index=0&id=3fc829be&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fc829be"]])

export default __exports__